module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-teus-dashboard"
  }, [_c('div', {
    staticClass: "dashboard-header"
  }, [_c('div', [_c('h2', {
    staticClass: "dashboard-title"
  }, [_vm._v("\n        " + _vm._s(_vm.isFromSalesPersonDashboard ?
    "Client TEUs Dashboard" :
    "Sales Person-Wise TEUs Dashboard") + "\n      ")]), _vm._v(" "), (_vm.isFromSalesPersonDashboard && _vm.selectedClientName) ? _c('p', {
    staticClass: "client-info"
  }, [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v("\n        Client: "), _c('strong', [_vm._v(_vm._s(_vm.selectedClientName))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header-actions"
  }, [(_vm.isFromSalesPersonDashboard) ? _c('button', {
    staticClass: "btn btn-secondary btn-sm",
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v("\n        Back to Sales Person Dashboard\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.refreshData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.isLoading
    }
  }), _vm._v("\n        Refresh\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "disabled": _vm.isLoading || !_vm.salesPersonData.length
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v("\n        Export to Excel\n      ")])])]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loading-container"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v("Loading TEUs data...")])]) : _vm._e(), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n    "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.errorMessage = ''
      }
    }
  }, [_c('span', [_vm._v("×")])])]) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "mb-1",
    staticStyle: {
      "font-size": "12px",
      "font-weight": "600"
    }
  }, [_vm._v("Date *")]), _vm._v(" "), _c('date-range-picker', {
    staticClass: "mb-1",
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": _vm.fetchData
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    staticClass: "mb-1",
    staticStyle: {
      "font-size": "12px",
      "font-weight": "600"
    }
  }, [_vm._v("Branch *")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": _vm.fetchData
    },
    model: {
      value: (_vm.Filter.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchfilter", $$v)
      },
      expression: "Filter.branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    staticClass: "mb-1",
    staticStyle: {
      "font-size": "12px",
      "font-weight": "600"
    }
  }, [_vm._v("Transport Type *")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.transportTypeList,
      "id": "transportTypeFilter",
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "All"
    },
    on: {
      "input": _vm.fetchData
    },
    model: {
      value: (_vm.Filter.transportTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "transportTypeFilter", $$v)
      },
      expression: "Filter.transportTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    staticClass: "mb-1",
    staticStyle: {
      "font-size": "12px",
      "font-weight": "600"
    }
  }, [_vm._v("Nomination Shipper *")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.nominationShipperList,
      "id": "is_nomination_shipper",
      "option-value": "value",
      "option-text": "text",
      "placeholder": "All Shippers"
    },
    on: {
      "input": _vm.fetchData
    },
    model: {
      value: (_vm.Filter.is_nomination_shipper),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "is_nomination_shipper", $$v)
      },
      expression: "Filter.is_nomination_shipper"
    }
  })], 1), _vm._v(" "), (!_vm.isFromSalesPersonDashboard) ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    staticClass: "mb-1",
    staticStyle: {
      "font-size": "12px",
      "font-weight": "600"
    }
  }, [_vm._v("Sales Person *")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "isDisabled": (_vm.$sessionsStorage.get('designation') != 'Admin' || _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh') ? true : false,
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "salesPersonFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Sales Person"
    },
    on: {
      "input": _vm.fetchData
    },
    model: {
      value: (_vm.Filter.salesPersonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "salesPersonFilter", $$v)
      },
      expression: "Filter.salesPersonFilter"
    }
  })], 1) : _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    staticClass: "mb-1",
    staticStyle: {
      "font-size": "12px",
      "font-weight": "600"
    }
  }, [_vm._v("Selected Sales Person")]), _vm._v(" "), _c('div', {
    staticClass: "selected-info"
  }, [_c('span', {
    staticClass: "badge badge-info"
  }, [_vm._v(_vm._s(_vm.getSalesPersonName(_vm.Filter.salesPersonFilter)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('button', {
    staticClass: "btn btn-warning btn-sm mt-2",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v("\n          Clear\n        ")])])], 1)], 1), _vm._v(" "), (!_vm.isLoading && _vm.salesPersonData.length > 0) ? _c('div', {
    staticClass: "dashboard-content"
  }, [_c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n              " + _vm._s(_vm.isFromSalesPersonDashboard ? "1" : _vm.totalSalesPersons) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.isFromSalesPersonDashboard ? "Client" : "Total Clients") + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.totalTeus))]), _vm._v(" "), _c('p', [_vm._v("Total TEUs")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.totalExportTeus))]), _vm._v(" "), _c('p', [_vm._v("Export TEUs")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.totalImportTeus))]), _vm._v(" "), _c('p', [_vm._v("Import TEUs")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.averageTeusPerSalesPerson))]), _vm._v(" "), _c('p', [_vm._v("Avg TEUs/Client")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.topSalesPerson.name))]), _vm._v(" "), _c('p', [_vm._v("Top Client (" + _vm._s(_vm.topSalesPerson.teus) + " TEUs)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.showCharts = !_vm.showCharts
      }
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.showCharts ? 'fa-chevron-down' : 'fa-chevron-right'
  }), _vm._v("\n              Charts & Visualizations\n              "), _c('span', {
    staticClass: "badge badge-info ml-2"
  }, [_vm._v(_vm._s(_vm.showCharts ? "Hide" : "Show"))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCharts),
      expression: "showCharts"
    }],
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('client-teus-flexible-chart', {
    attrs: {
      "chart-data": _vm.allClientsChartData,
      "chart-height": 500,
      "chart-type": "bar",
      "chart-title": "Clients TEUs Overview",
      "chart-icon": "fa-bar-chart",
      "default-limit": 20
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('client-teus-flexible-chart', {
    attrs: {
      "chart-data": _vm.allClientsChartData,
      "chart-height": 450,
      "chart-type": "bar",
      "chart-title": "Top Performers",
      "chart-icon": "fa-trophy",
      "default-limit": 10
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('client-teus-flexible-chart', {
    attrs: {
      "chart-data": _vm.allClientsChartData,
      "chart-height": 450,
      "chart-type": "pie",
      "chart-title": "TEUs Distribution",
      "chart-icon": "fa-pie-chart",
      "default-limit": 10
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "chart-card"
  }, [_c('div', {
    staticClass: "chart-header"
  }, [_c('div', {
    staticClass: "chart-title"
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _vm._v("\n                      Monthly TEUs Trend\n                      "), _c('span', {
    staticClass: "badge badge-primary ml-2"
  }, [_vm._v(_vm._s(_vm.selectedTrendSalesPersons.length) + " Clients")]), _vm._v(" "), _c('span', {
    staticClass: "badge badge-info ml-2"
  }, [_vm._v(_vm._s(_vm.dynamicTrendChartHeight) + "px")])]), _vm._v(" "), _c('div', {
    staticClass: "chart-controls"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Show:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trendSalesPersonLimit),
      expression: "trendSalesPersonLimit"
    }],
    staticClass: "form-control form-control-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trendSalesPersonLimit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateTrendSalesPersons]
    }
  }, [_c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Top 5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Top 10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("Top 15")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("Top 20")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All")])])])]), _vm._v(" "), _c('client-teus-line-chart', {
    attrs: {
      "chart-data": _vm.monthlyTrendChartData,
      "chart-height": _vm.dynamicTrendChartHeight
    }
  })], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-card"
  }, [_c('h4', {
    staticClass: "table-title"
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("\n        " + _vm._s(_vm.isFromSalesPersonDashboard ?
    "Client TEUs Details" :
    "Detailed TEUs Data") + "\n        "), _c('span', {
    staticClass: "badge badge-primary ml-2"
  }, [_vm._v(_vm._s(_vm.isFromSalesPersonDashboard ?
    "1 Client" :
    _vm.filteredAndSortedData.length + " Clients"))])]), _vm._v(" "), _c('div', {
    staticClass: "table-filters mb-3"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Search by client name..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "excel-header",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("S.No")]), _vm._v(" "), _c('th', {
    staticClass: "excel-header",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('clientName')
      }
    }
  }, [_vm._v("\n                Client Name\n                "), (_vm.sortColumn !== 'clientName') ? _c('i', {
    staticClass: "fa fa-sort"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortColumn === 'clientName' && _vm.sortDirection === 'asc'
  ) ? _c('i', {
    staticClass: "fa fa-sort-asc"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortColumn === 'clientName' && _vm.sortDirection === 'desc'
  ) ? _c('i', {
    staticClass: "fa fa-sort-desc"
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "excel-header",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n                Nomination Shipper/Type\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "excel-header",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _vm._l((_vm.uniqueMonths), function(month) {
    return _c('th', {
      key: month,
      staticClass: "excel-month-header",
      attrs: {
        "colspan": _vm.Filter.transportTypeFilter === 'All' ?
          3 :
          _vm.Filter.transportTypeFilter === 'Export' ?
          1 :
          1
      }
    }, [_vm._v("\n                " + _vm._s(month) + "\n              ")])
  }), _vm._v(" "), (
    _vm.Filter.transportTypeFilter === 'Export' ||
    _vm.Filter.transportTypeFilter === 'All'
  ) ? _c('th', {
    staticClass: "excel-total-header",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('totalExport')
      }
    }
  }, [_vm._v("\n                Export Total\n                "), (_vm.sortColumn !== 'totalExport') ? _c('i', {
    staticClass: "fa fa-sort"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortColumn === 'totalExport' && _vm.sortDirection === 'asc'
  ) ? _c('i', {
    staticClass: "fa fa-sort-asc"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortColumn === 'totalExport' && _vm.sortDirection === 'desc'
  ) ? _c('i', {
    staticClass: "fa fa-sort-desc"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.Filter.transportTypeFilter === 'Import' ||
    _vm.Filter.transportTypeFilter === 'All'
  ) ? _c('th', {
    staticClass: "excel-total-header",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('totalImport')
      }
    }
  }, [_vm._v("\n                Import Total\n                "), (_vm.sortColumn !== 'totalImport') ? _c('i', {
    staticClass: "fa fa-sort"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortColumn === 'totalImport' && _vm.sortDirection === 'asc'
  ) ? _c('i', {
    staticClass: "fa fa-sort-asc"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortColumn === 'totalImport' && _vm.sortDirection === 'desc'
  ) ? _c('i', {
    staticClass: "fa fa-sort-desc"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.Filter.transportTypeFilter === 'All') ? _c('th', {
    staticClass: "excel-total-header",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "rowspan": "4"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('total')
      }
    }
  }, [_vm._v("\n                Total\n                "), (_vm.sortColumn !== 'total') ? _c('i', {
    staticClass: "fa fa-sort"
  }) : _vm._e(), _vm._v(" "), (_vm.sortColumn === 'total' && _vm.sortDirection === 'asc') ? _c('i', {
    staticClass: "fa fa-sort-asc"
  }) : _vm._e(), _vm._v(" "), (_vm.sortColumn === 'total' && _vm.sortDirection === 'desc') ? _c('i', {
    staticClass: "fa fa-sort-desc"
  }) : _vm._e()]) : _vm._e()], 2), _vm._v(" "), _c('tr', [_vm._l((_vm.uniqueMonths), function(month) {
    return [(_vm.Filter.transportTypeFilter === 'All') ? _c('th', {
      staticClass: "excel-sub-header excel-total"
    }, [_vm._v("\n                  Total\n                ")]) : _vm._e(), _vm._v(" "), (
      _vm.Filter.transportTypeFilter === 'Export' ||
      _vm.Filter.transportTypeFilter === 'All'
    ) ? _c('th', {
      staticClass: "excel-sub-header excel-export"
    }, [_vm._v("\n                  Export\n                ")]) : _vm._e(), _vm._v(" "), (
      _vm.Filter.transportTypeFilter === 'Import' ||
      _vm.Filter.transportTypeFilter === 'All'
    ) ? _c('th', {
      staticClass: "excel-sub-header excel-import"
    }, [_vm._v("\n                  Import\n                ")]) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredAndSortedData), function(client, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "client-name-cell",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.navigateToSalesPersonDashboard(client)
        }
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(client.clientName || client.salesPersonName))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-external-link ml-1 text-primary",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), (client.loginClientTime || client.updateClientTime) ? _c('div', {
      staticClass: "client-times text-muted small mt-1"
    }, [(client.loginClientTime) ? _c('div', [_c('i', {
      staticClass: "fa fa-calendar-plus-o"
    }), _vm._v(" Created:\n                    " + _vm._s(client.loginClientTime) + "\n                  ")]) : _vm._e(), _vm._v(" "), (client.CreatedBy) ? _c('div', [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" Created By:\n                    " + _vm._s(client.CreatedBy) + "\n                  ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(client.NominationShipper || client.NominationShipper) + "/\n                " + _vm._s(client.Type || client.Type) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(client.BranchName || client.BranchName) + "\n              ")]), _vm._v(" "), _vm._l((_vm.uniqueMonths), function(month) {
      return [(_vm.Filter.transportTypeFilter === 'All') ? _c('td', {
        staticClass: "excel-cell excel-total-cell",
        class: _vm.getTeusClass(client.monthsMap[month]),
        attrs: {
          "title": _vm.getTeusTooltip(client.monthsMap[month])
        }
      }, [_vm._v("\n                  " + _vm._s(client.monthsMap[month] || "-") + "\n                ")]) : _vm._e(), _vm._v(" "), (
        _vm.Filter.transportTypeFilter === 'Export' ||
        _vm.Filter.transportTypeFilter === 'All'
      ) ? _c('td', {
        staticClass: "excel-cell excel-export-cell",
        class: _vm.getTeusClass(client.exportMonthsMap[month]),
        attrs: {
          "title": _vm.getTeusTooltip(client.exportMonthsMap[month])
        }
      }, [_vm._v("\n                  " + _vm._s(client.exportMonthsMap[month] || "-") + "\n                ")]) : _vm._e(), _vm._v(" "), (
        _vm.Filter.transportTypeFilter === 'Import' ||
        _vm.Filter.transportTypeFilter === 'All'
      ) ? _c('td', {
        staticClass: "excel-cell excel-import-cell",
        class: _vm.getTeusClass(client.importMonthsMap[month]),
        attrs: {
          "title": _vm.getTeusTooltip(client.importMonthsMap[month])
        }
      }, [_vm._v("\n                  " + _vm._s(client.importMonthsMap[month] || "-") + "\n                ")]) : _vm._e()]
    }), _vm._v(" "), (
      _vm.Filter.transportTypeFilter === 'Export' ||
      _vm.Filter.transportTypeFilter === 'All'
    ) ? _c('td', {
      staticClass: "excel-cell excel-total-cell"
    }, [_c('strong', [_vm._v(_vm._s(client.totalExport))])]) : _vm._e(), _vm._v(" "), (
      _vm.Filter.transportTypeFilter === 'Import' ||
      _vm.Filter.transportTypeFilter === 'All'
    ) ? _c('td', {
      staticClass: "excel-cell excel-import-cell"
    }, [_c('strong', [_vm._v(_vm._s(client.totalImport))])]) : _vm._e(), _vm._v(" "), (_vm.Filter.transportTypeFilter === 'All') ? _c('td', {
      staticClass: "excel-cell excel-total-cell"
    }, [_c('strong', [_vm._v(_vm._s(client.total))])]) : _vm._e()], 2)
  })), _vm._v(" "), (_vm.filteredAndSortedData.length > 0) ? _c('tfoot', [_c('tr', {
    staticClass: "excel-footer-row"
  }, [_vm._m(8), _vm._v(" "), _vm._l((_vm.uniqueMonths), function(month) {
    return [(_vm.Filter.transportTypeFilter === 'All') ? _c('td', {
      staticClass: "excel-cell excel-total-cell"
    }, [_c('strong', [_vm._v(_vm._s(_vm.getMonthTotal(month)))])]) : _vm._e(), _vm._v(" "), (
      _vm.Filter.transportTypeFilter === 'Export' ||
      _vm.Filter.transportTypeFilter === 'All'
    ) ? _c('td', {
      staticClass: "excel-cell excel-export-cell"
    }, [_c('strong', [_vm._v(_vm._s(_vm.getMonthExportTotal(month)))])]) : _vm._e(), _vm._v(" "), (
      _vm.Filter.transportTypeFilter === 'Import' ||
      _vm.Filter.transportTypeFilter === 'All'
    ) ? _c('td', {
      staticClass: "excel-cell excel-import-cell"
    }, [_c('strong', [_vm._v(_vm._s(_vm.getMonthImportTotal(month)))])]) : _vm._e()]
  }), _vm._v(" "), (
    _vm.Filter.transportTypeFilter === 'Export' ||
    _vm.Filter.transportTypeFilter === 'All'
  ) ? _c('td', {
    staticClass: "excel-cell excel-export-cell"
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalExportTeus))])]) : _vm._e(), _vm._v(" "), (
    _vm.Filter.transportTypeFilter === 'Import' ||
    _vm.Filter.transportTypeFilter === 'All'
  ) ? _c('td', {
    staticClass: "excel-cell excel-import-cell"
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalImportTeus))])]) : _vm._e(), _vm._v(" "), (_vm.Filter.transportTypeFilter === 'All') ? _c('td', {
    staticClass: "excel-cell excel-total-cell"
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalTeus))])]) : _vm._e()], 2)]) : _vm._e()])]), _vm._v(" "), (_vm.filteredAndSortedData.length === 0) ? _c('div', {
    staticClass: "text-center py-4"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No data found matching your search criteria.")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.salesPersonData.length === 0 && !_vm.errorMessage) ? _c('div', {
    staticClass: "no-data-container"
  }, [_c('i', {
    staticClass: "fa fa-inbox fa-3x text-muted mb-3"
  }), _vm._v(" "), _c('h4', [_vm._v("No Data Available")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("There is no TEUs data available at the moment.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.refreshData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n      Try Again\n    ")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-border text-primary",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon bg-primary"
  }, [_c('i', {
    staticClass: "fa fa-building"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon bg-success"
  }, [_c('i', {
    staticClass: "fa fa-cubes"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon bg-info"
  }, [_c('i', {
    staticClass: "fa fa-ship"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon bg-warning"
  }, [_c('i', {
    staticClass: "fa fa-truck"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon bg-info"
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon bg-warning"
  }, [_c('i', {
    staticClass: "fa fa-star"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "color-legend"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_c('strong', [_vm._v("Color Legend:")]), _vm._v(" "), _c('span', {
    staticClass: "text-success font-weight-bold ml-2"
  }, [_vm._v("🟢 High (>30 TEUs)")]), _vm._v(" "), _c('span', {
    staticClass: "text-info ml-2"
  }, [_vm._v("🔵 Good (20-30 TEUs)")]), _vm._v(" "), _c('span', {
    staticClass: "text-warning ml-2"
  }, [_vm._v("🟡 Medium (10-20 TEUs)")]), _vm._v(" "), _c('span', {
    staticClass: "text-muted ml-2"
  }, [_vm._v("⚪ Low (<10 TEUs)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "excel-footer-label",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Total")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb1ad84e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/SalesPersonTeusDashboard.vue
// module id = 2901
// module chunks = 0